export default __webpack_public_path__ + "static/media/avatar.d2c16d61.png";